import React from 'react';

import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';
import { registerEntityFieldConfig } from 'components/Entities/EntityDetailsTab/entityFieldConfig';

import { EntityModules } from 'core/constants';

import { formatLibraryId } from 'utils/formatters/libraryId';
import { choiceKeyOf } from 'utils/library';

import ControlPutInPlaceRows from './components/ControlPutInPlaceRows/ControlPutInPlaceRows';
import ControlStatusChip from './components/ControlStatusChip';
import { CONTROL_FIELD, CONTROL_OWNER_FILTER, ControlStatus } from './constants';
import { CONTROL_RECORD_REQUIRED_KEYS, isProposed } from './utils';

registerEntityFieldConfig(EntityModules.Controls, {
  renderers: {
    [CONTROL_FIELD.id]: (value) => formatLibraryId(EntityModules.Controls, value as number | null),
    [CONTROL_FIELD.status]: (value) => {
      const status = choiceKeyOf(value);
      return status ? (
        <ControlStatusChip status={status as ControlStatus} />
      ) : (
        <EmptyValue id="empty-value">-</EmptyValue>
      );
    },
  },
  rules: {
    isVisible: (fieldKey, values) => fieldKey !== CONTROL_FIELD.dueDate || isProposed(values[CONTROL_FIELD.status]),
    isRequired: (fieldKey) => CONTROL_RECORD_REQUIRED_KEYS.has(fieldKey),
  },
  userFilters: { [CONTROL_FIELD.owner]: CONTROL_OWNER_FILTER },
  ExtraRows: ControlPutInPlaceRows,
});
